import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as globals from '@reusable/services/globals';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
@Injectable()
export class TeamShipmentService {
  requestOptions = this.gtn.getHeaders();

  constructor(private gtn: globals.GetTokenNow, private toastr: ToastrService, private httpClient: HttpClient) { }

  getShipmentsList(sort, records, pageNumber, queries?) {
    this.requestOptions['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/team/shipments/list/sortBy-${sort}/${records}/${pageNumber}/`, this.requestOptions)
      .pipe(map(res => res as any));
  }

  createShipment(body: IShipmentBody) {
    return this.httpClient.post(`${globals.domain}/team/shipments/create/`, body, this.requestOptions).pipe(map(res => res as any));
  }

  addToShipment(shipmentId: string, body: { directOrderPartsIds: string[] }) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/${shipmentId}/add-items/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }

  removePartFromShipment(shipmentId: string, body: { directOrderPartsIds: string[] }) {
    return this.httpClient
      .put(`${globals.domain}/team/shipments/${shipmentId}/remove-items/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }

  deletedShipment(shipmentId: string) {
    return this.httpClient.put(`${globals.domain}/team/shipments/${shipmentId}/remove/`, {}, this.requestOptions).pipe(map(res => res as any));
  }

  updateDeliveryAddress(shipmentId: string, address: IDeliveryAddress) {
    return this.httpClient
      .put(`${globals.domain}/team/shipments/${shipmentId}/update-address/`, address, this.requestOptions)
      .pipe(map(res => res as any));
  }

  updateShippingCarrier(shipmentId: string, body: { shippingCarrier: string; trackingNumber: string; expectedDeliveryAt: any }) {
    return this.httpClient
      .put(`${globals.domain}/team/shipments/${shipmentId}/update-shipping-carrier/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }

  readyToShip(shipmentId: string, body: { isReadyToShip: boolean }) {
    return this.httpClient
      .put(`${globals.domain}/team/shipments/${shipmentId}/ready-to-ship/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }

  changeToShipped(body) {
    return this.httpClient.put(`${globals.domain}/team/shipments/mark-as-shipped/`, body, this.requestOptions).pipe(map(res => res as any));
  }

  changeToDelivered(shipmentId: string, body: { isDelivered: boolean }) {
    return this.httpClient
      .put(`${globals.domain}/team/shipments/${shipmentId}/delivered/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }

  createAramexTrackingNum(shipmentId: string) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/${shipmentId}/create-aramex/`, {}, this.requestOptions)
      .pipe(map(res => res as any));
  }
  createBulkAramexShipment(body) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/create-bulk-aramex-shipments/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }
  createBulkAjexShipment(body) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/create-bulk-ajex-shipments/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }
  createBulkRedboxShipment(body) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/create-bulk-redbox-shipments/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }
  createBulkLogistiqShipment(body) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/create-bulk-logistiq-shipments/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }
  createBulkThreeSpeedShipment(body) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/create-bulk-three-speed-shipments/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }

  generateAramexLabel(shipmentId: string) {
    return this.httpClient
      .get(`${globals.domain}/team/shipments/${shipmentId}/generate-aramex-label/`, this.requestOptions)
      .pipe(map(res => res as any));
  }

  createRedboxTrackingNum(shipmentId: string) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/${shipmentId}/create-redbox/`, {}, this.requestOptions)
      .pipe(map(res => res as any));
  }

  generateRedboxLabel(shipmentId: string) {
    return this.httpClient
      .get(`${globals.domain}/team/shipments/${shipmentId}/generate-redbox-label/`, this.requestOptions)
      .pipe(map(res => res as any));
  }
  createAjexTrackingNum(shipmentId: string) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/${shipmentId}/create-ajex/`, {}, this.requestOptions)
      .pipe(map(res => res as any));
  }

  generateAjexLabel(shipmentId: string) {
    return this.httpClient
      .get(`${globals.domain}/team/shipments/${shipmentId}/generate-ajex-label/`, this.requestOptions)
      .pipe(map(res => res as any));
  }

  createLogistiqTrackingNum(shipmentId: string) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/${shipmentId}/create-logistiq/`, {}, this.requestOptions)
      .pipe(map(res => res as any));
  }

  generateLogistiqLabel(shipmentId: string) {
    return this.httpClient
      .get(`${globals.domain}/team/shipments/${shipmentId}/generate-logistiq-label/`, this.requestOptions)
      .pipe(map(res => res as any));
  }

  getLogistiqShipmentSteps(trackingNumber: string) {
    return this.httpClient.get(`${globals.domain}/shipments/logistiq/get-shipment-steps/${trackingNumber}`, this.requestOptions).pipe(map(res => res as any));
  }


  createThreeSpeedTrackingNum(shipmentId: string) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/${shipmentId}/create-three-speed/`, {}, this.requestOptions)
      .pipe(map(res => res as any));
  }

  generateThreeSpeedLabel(shipmentId: string, customId: string) {
    this.requestOptions['responseType'] = 'blob';
    return this.httpClient
      .get(`${globals.domain}/team/shipments/${shipmentId}/generate-three-speed-label/`, this.requestOptions)
      .pipe(map(res => {
        const result = res as any;
        if (result.type === 'application/pdf') {
          const blob = res;
          const filename = `${customId}-shipment.pdf`;
          FileSaver.saveAs(blob, filename);
          return true;
        } else {
          this.toastr.error('حدث خطأ اثناء تحميل الملصقات');
          return false;
        }
      }));
  }

  getThreeSpeedShipmentSteps(trackingNumber: string) {
    return this.httpClient.get(`${globals.domain}/shipments/three-speed/get-shipment-steps/${trackingNumber}`, this.requestOptions).pipe(map(res => res as any));
  }
  viewShipment(shipmentId: string): Observable<any> {
    return this.httpClient.get(`${globals.domain}/team/shipments/${shipmentId}/view/`, this.requestOptions).pipe(map(res => res as any));
  }

  printLabel(shipmentId: string, customId) {
    this.requestOptions['responseType'] = 'blob';
    return this.httpClient.get(`${globals.domain}/team/shipments/${shipmentId}/generate-label/`, this.requestOptions).pipe(map(res => {
      const result = res as any;
      if (result.type === 'application/pdf') {
        const blob = res;
        const filename = `${customId}-shipment.pdf`;
        FileSaver.saveAs(blob, filename);
      } else {
        this.toastr.error('حدث خطأ اثناء تحميل الملصقات');
      }
    }));
  }

  printManifest(shipmentId: string, customId) {
    this.requestOptions['responseType'] = 'blob';
    return this.httpClient.get(`${globals.domain}/team/shipments/${shipmentId}/generate-manifest/`, this.requestOptions).pipe(map((res:any) => {
      const result = res as any;
      if (result.type === 'application/pdf') {
        const blob = res;
        const filename = `${customId}-shipment-manifest.pdf`;
        FileSaver.saveAs(blob, filename);
      } else {
        this.toastr.error('حدث خطأ اثناء تحميل بيان الشحنة');
      }
    }));
  }

  sendShippingPolicyViaEmail(shipmentId, queries) {
    this.requestOptions['params'] = queries;
    return this.httpClient.get(`${globals.domain}/team/shipments/${shipmentId}/send-email/`, this.requestOptions).pipe(map(res => res as any));
  }

  sendShippingPolicyViaSMS(shipmentId, queries) {
    this.requestOptions['params'] = queries;
    return this.httpClient.get(`${globals.domain}/team/shipments/${shipmentId}/send-sms/`, this.requestOptions).pipe(map(res => res as any));
  }
  getShipmentSteps(trackingNumber) {
    return this.httpClient.get(`${globals.domain}/shipments/aramex/get-shipment-steps/${trackingNumber}`, this.requestOptions).pipe(map(res => res as any));
  }

  createOtoOrder(shipmentId) {
    return this.httpClient.post(`${globals.domain}/team/shipments/${shipmentId}/create-oto-order/`, {}, this.requestOptions).pipe(map(res => res as any));
  }
  cancelOtoOrder(shipmentId) {
    return this.httpClient
      .delete(`${globals.domain}/team/shipments/${shipmentId}/cancel-oto-order/`, this.requestOptions)
      .pipe(map(res => res as any));
  }
  createOtoReturnOrder(body: { shipmentId: string; outwardShipmentId: string }) {
    return this.httpClient
      .post(`${globals.domain}/team/shipments/create-oto-return-order/`, body, this.requestOptions)
      .pipe(map(res => res as any));
  }

}

export interface IShipmentBody {
  shipment: {
    directOrderId: string;
    directOrderPartsIds: string[];
    numberOfBoxes: number;
    shipmentType: string;
    shippingCarrier: string;
    deliveryAddress: IDeliveryAddress;
    expectedDeliveryAt: any;
    shipperCityId: string;
  };
}

export interface IDeliveryAddress {
  deliveryAddress: {
    name: {
      first: string;
      last: string;
    };
    address: {
      cityId: string;
      area: string;
      district: string;
      street: string;
      landmark: string;
    };
    mobile: string;
  };
}